import { render } from "./domains.vue?vue&type=template&id=f0204186&lang=pug"
import script from "./domains.vue?vue&type=script&setup=true&lang=js"
export * from "./domains.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__